import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterSandown() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-sandown",
    name: "Painters Sandown",
    location: "Sandown, Cape Town",
    rating: 4.9,
    reviews: 189,
    specialties: ["Luxury Estates", "Upscale Residences", "Premium Finishes", "Heritage Properties"],
    image: "https://public.readdy.ai/ai/img_res/55c37b52d98fc6639c13efbdf0a22129.jpg",
    verified: true,
    yearsExperience: 18,
    website: "https://painterssandown.co.za",
    email: "info@painterssandown.co.za",
    description: "Professional painting services in Sandown and surrounding prestigious areas. We specialize in luxury estates and upscale residences with expertise in premium finishes and comprehensive property enhancement solutions.",
    services: [
      "Luxury Home Painting",
      "Estate Property Painting", 
      "Premium Interior Finishes",
      "Heritage Restoration",
      "Decorative Techniques",
      "Waterproofing Services",
      "Exterior Protection Systems",
      "Color Design Consultation"
    ],
    serviceAreas: ["Sandown", "Bloubergstrand", "Table View", "Parklands", "Big Bay", "Melkbosstrand", "West Beach", "Northern Suburbs"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20interior%20living%20room%20painted%20by%20professional%20painters%20in%20Sandown%2C%20luxury%20estate%20home%20with%20fresh%20white%20walls%2C%20quality%20premium%20paint%20finish%2C%20mountain%20view%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work%2C%20elegant%20design&width=400&height=300&seq=sandown-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20estate%20painting%20project%20in%20Sandown%20Cape%20Town%2C%20luxury%20property%20with%20fresh%20premium%20paint%2C%20professional%20painters%20working%2C%20quality%20exterior%20finish%2C%20upscale%20residential%20setting%2C%20well-maintained%20estate&width=400&height=300&seq=sandown-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Luxury%20estate%20painting%20project%20in%20Sandown%2C%20professional%20painters%20working%20on%20upscale%20home%20exterior%2C%20quality%20premium%20paint%20finish%2C%20elegant%20architecture%2C%20organized%20work%20site&width=400&height=300&seq=sandown-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Kitchen%20interior%20painting%20in%20Sandown%20luxury%20home%2C%20fresh%20painted%20walls%2C%20high-end%20kitchen%20design%2C%20quality%20premium%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work&width=400&height=300&seq=sandown-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Master%20bedroom%20interior%20painting%20in%20Sandown%20estate%20home%2C%20fresh%20painted%20walls%2C%20elegant%20luxury%20bedroom%20design%2C%20quality%20premium%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work&width=400&height=300&seq=sandown-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20facade%20painting%20in%20Sandown%20luxury%20estate%2C%20professional%20painters%20working%20on%20prestigious%20home%2C%20quality%20premium%20finish%2C%20elegant%20architecture%2C%20pristine%20work%20environment&width=400&height=300&seq=sandown-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Richard Montgomery",
        rating: 5,
        comment: "Exceptional work on our Sandown estate. The team demonstrated the highest level of professionalism and craftsmanship. The premium finishes are absolutely stunning and have truly elevated our home."
      },
      {
        name: "Elizabeth van Rooyen", 
        rating: 5,
        comment: "Outstanding service from start to finish. They completed our luxury home painting with meticulous attention to detail and the results exceeded our high expectations. Highly recommend for prestigious properties."
      },
      {
        name: "William Harrison",
        rating: 5,
        comment: "Professional painters who truly understand luxury home requirements. They were impeccable in their work, respectful of our property, and the quality is simply outstanding. Our estate looks magnificent."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Sandown | Professional Luxury Painting Services Cape Town | Estate Home Specialists";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Sandown offers professional painting services for luxury estates and upscale residences in Sandown, Cape Town. Specializing in premium finishes, heritage restoration, and comprehensive property enhancement. Get a free quote today.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Sandown, luxury home painters Cape Town, estate property painting, premium painting services, upscale residential painting');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-blue-600 to-blue-800">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20prestigious%20luxury%20estate%20home%20in%20Sandown%20Cape%20Town%2C%20upscale%20residential%20property%20with%20Table%20Mountain%20and%20ocean%20views%2C%20painters%20in%20clean%20uniforms%20with%20premium%20equipment%2C%20elegant%20architecture%20with%20manicured%20gardens%2C%20bright%20natural%20lighting%2C%20high%20quality%20luxury%20residential%20painting%20project&width=1200&height=600&seq=sandown-painters-hero&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white">
            <div className="flex items-center mb-4">
              <h1 className="text-4xl md:text-5xl font-bold mr-4">{painter.name}</h1>
              {painter.verified && (
                <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                  <i className="ri-shield-check-line mr-1"></i>
                  Verified
                </div>
              )}
            </div>
            
            <p className="text-xl mb-4 flex items-center">
              <i className="ri-map-pin-line mr-2"></i>
              {painter.location}
            </p>
            
            <div className="flex items-center space-x-6 mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill ${i < Math.floor(painter.rating) ? 'text-yellow-400' : 'text-gray-400'}`}></i>
                ))}
                <span className="ml-2">{painter.rating} ({painter.reviews} reviews)</span>
              </div>
              <span>{painter.yearsExperience} years experience</span>
            </div>
            
            <div className="flex space-x-4">
              <button 
                onClick={() => navigate('/quote')}
                className="bg-lime-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', label: 'Overview' },
              { id: 'services', label: 'Services' },
              { id: 'gallery', label: 'Gallery' },
              { id: 'reviews', label: 'Reviews' },
              { id: 'contact', label: 'Contact' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-lime-500 text-lime-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Professional Painting Services in Sandown</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {painter.description}
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Luxury Estate Painting Specialists</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Sandown is one of Cape Town's most prestigious residential areas, renowned for its luxury estates, upscale properties, and discerning homeowners who demand the highest standards of quality and service. Our team has over 18 years of specialized experience working in this exclusive neighborhood, understanding the exacting standards expected by Sandown property owners and the unique requirements of luxury residential properties. We've built our reputation on delivering exceptional painting services that enhance property value while providing superior protection and timeless aesthetic appeal.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  The properties in Sandown represent significant investments and showcase some of the finest residential architecture in Cape Town. Our painting services are specifically tailored to meet the exacting standards of luxury homeowners, using only the finest materials, employing master craftsmen, and providing meticulous attention to every detail. We understand that your estate is more than just a property – it's a reflection of your success, taste, and lifestyle. That's why we approach every project with the professionalism, discretion, and excellence that Sandown homeowners expect and deserve.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Premium Materials and Master Craftsmanship</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Luxury properties demand premium materials and master-level craftsmanship. We exclusively use the finest paints and coatings available, sourced from the world's leading manufacturers and selected specifically for their superior quality, durability, and finish. Our paint selection includes premium products with advanced features such as exceptional coverage, superior color retention, enhanced washability, and resistance to fading and environmental damage. These top-tier materials ensure your property maintains its pristine appearance for years while providing maximum protection against the elements.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  Our team consists of master painters with decades of combined experience in luxury residential projects. Each member of our team has been carefully selected for their exceptional skills, attention to detail, and commitment to excellence. We invest heavily in ongoing training to ensure our painters are familiar with the latest techniques, materials, and industry innovations. This dedication to excellence means you can trust that your Sandown estate is in the most capable hands, and the finished result will meet the highest standards of quality and craftsmanship that luxury properties demand.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Comprehensive Estate Services</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Luxury estates require comprehensive painting services that go beyond basic application. We offer complete solutions including detailed property assessment, expert color consultation and design services, specialized surface preparation and restoration, application of premium coatings and finishes, and ongoing maintenance programs to preserve your investment. Our project management approach ensures seamless coordination, minimal disruption to your household, and clear communication throughout every phase of the project. We understand the importance of discretion and professionalism when working in prestigious residential areas.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  We work closely with estate managers, interior designers, architects, and homeowners to ensure every aspect of the painting project aligns with your vision and expectations. Our comprehensive approach includes protecting valuable furnishings and artwork, maintaining immaculate work areas, coordinating with other contractors and service providers, and ensuring all work meets the highest standards of quality. We can work in stages if needed to accommodate your schedule and lifestyle, ensuring minimal disruption while delivering exceptional results that enhance your property's beauty and value.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Premium Interior Finishes and Design</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Luxury interiors require finishes that are both beautiful and sophisticated. We specialize in premium interior painting that creates stunning living spaces worthy of Sandown's finest estates. Our services include standard premium finishes with flawless application, decorative techniques such as Venetian plaster and specialty textures, custom color matching and development, feature walls and accent applications, and coordination with interior design schemes. We use only the finest low-VOC paints that are safe for your family while providing exceptional coverage, durability, and a luxurious finish.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  Our color consultation services are particularly valuable for luxury properties, where color choices can significantly impact the overall aesthetic and atmosphere. Our experienced consultants understand how to work with natural light, architectural features, and existing design elements to create cohesive, sophisticated color schemes that enhance your home's beauty and reflect your personal style. We can provide sample applications and mockups to ensure you're completely satisfied with color selections before proceeding with the full project, giving you confidence in the final result.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Exterior Protection and Enhancement</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Protecting and enhancing your estate's exterior requires specialized expertise and premium materials. Our exterior painting services include comprehensive surface preparation and restoration, treatment of any existing damage or deterioration, application of specialized primers and sealers, multiple coats of premium weather-resistant paint, and protective coatings for maximum durability. We pay meticulous attention to architectural details, trim work, and decorative elements, ensuring every aspect of your property's exterior is perfectly finished and fully protected.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-8">
                  We also offer specialized exterior services including waterproofing systems for walls and foundations, roof painting and protective coatings, restoration of heritage architectural features, and ongoing maintenance programs. Our comprehensive approach ensures your estate's exterior not only looks magnificent but is also fully protected from weather damage, moisture penetration, and environmental degradation. We understand that your property's exterior is the first impression visitors receive, and we ensure it reflects the quality and prestige of your Sandown estate.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Specialties</h3>
                    <div className="flex flex-wrap gap-2">
                      {painter.specialties.map((specialty, index) => (
                        <span key={index} className="bg-lime-100 text-lime-800 px-3 py-1 rounded-full text-sm font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Service Areas</h3>
                    <div className="space-y-2">
                      {painter.serviceAreas.slice(0, 4).map((area, index) => (
                        <div key={index} className="flex items-center text-gray-700">
                          <i className="ri-map-pin-line mr-2 text-lime-500"></i>
                          {area}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                  <div className="mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20luxury%20estate%20home%20in%20Sandown%20Cape%20Town%2C%20prestigious%20residential%20property%20with%20mountain%20views%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20elegant%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=sandown-sidebar-image&orientation=landscape"
                      alt="Professional painters Sandown luxury estate painting services Cape Town upscale properties"
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-lime-500"></i>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-global-line mr-3 text-lime-500"></i>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        Visit Website
                      </a>
                    </div>
                  </div>
                  
                  <button 
                    onClick={() => navigate('/quote')}
                    className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Get Free Quote
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'services' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Comprehensive Painting Services in Sandown</h2>
              
              <div className="mb-12">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Luxury Estate Painting Solutions</h3>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Our painting services are specifically designed for the unique requirements of Sandown's luxury estates and upscale properties. From premium interior finishes to comprehensive exterior protection systems, we provide exceptional solutions that combine the finest materials with master craftsmanship and meticulous attention to detail.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                {painter.services.map((service, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center mb-4">
                      <i className="ri-brush-line text-2xl text-lime-500 mr-3"></i>
                      <h3 className="text-lg font-semibold text-gray-900">{service}</h3>
                    </div>
                    <p className="text-gray-600">Professional {service.toLowerCase()} services with premium materials and expert luxury residential application techniques.</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Premium Interior Excellence</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Our interior painting services create stunning luxury spaces that reflect the prestige of Sandown estates. We use only the finest paints with exceptional coverage and durability. Our color consultation services help you choose sophisticated palettes that enhance architectural features and create the perfect atmosphere for luxury living.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We understand the importance of protecting valuable furnishings and artwork during painting projects. Our team takes extraordinary precautions to protect your belongings, maintaining immaculate work areas throughout the project. We work with discretion and professionalism to minimize disruption while delivering exceptional results.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Exterior Protection and Prestige</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Exterior painting for luxury estates requires premium materials and master-level craftsmanship. We use the finest weather-resistant paints and protective coatings available. Our comprehensive exterior painting process includes meticulous surface preparation, specialized primers, and multiple coats of premium paint for maximum protection and beauty.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We also offer specialized services including waterproofing systems, heritage restoration, and ongoing maintenance programs. Our comprehensive approach ensures your estate's exterior reflects its prestige while being fully protected from environmental damage for years to come.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'gallery' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Recent Painting Projects in Sandown</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Explore our portfolio of recent painting projects throughout Sandown and surrounding prestigious areas. Each project demonstrates our commitment to excellence and our expertise in luxury estate painting applications.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {painter.gallery.map((image, index) => (
                  <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    <img 
                      src={image} 
                      alt={`${painter.name} project ${index + 1}`}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-900 mb-2">Sandown Project {index + 1}</h3>
                      <p className="text-gray-600 text-sm">Professional luxury painting with premium materials and master craftsmanship.</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews and Testimonials</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Read what our satisfied customers throughout Sandown have to say about our painting services. Our commitment to excellence and customer satisfaction is reflected in these genuine reviews from luxury property owners in the area.
              </p>
              
              <div className="space-y-6">
                {painter.testimonials.map((testimonial, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                        ))}
                      </div>
                      <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{testimonial.comment}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Painters Sandown</h2>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Ready to enhance your Sandown estate with professional luxury painting services? Contact us today for a private consultation and detailed quote. We're here to help you achieve exceptional results that reflect the prestige of your property.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Email</h3>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Website</h3>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        {painter.website}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Service Area</h3>
                      <p className="text-gray-700">{painter.location} and surrounding prestigious areas</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Get Your Free Quote Today</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Request a free, no-obligation quote for your Sandown painting project. Our experienced team will assess your estate and provide detailed recommendations tailored to luxury property requirements.
                </p>
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                >
                  Request Free Quote
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
